import { useT } from '../../i18n/i18n';

// Progress bar (01 / 02 / 04 / 05): 8px on phone, 6px (`slim`) in the iPad bar and pane headers,
// primary fill on a bg.high track; optional trailing label or percentage pill (02 "65%").
export function ProgressBar(props: { value: number; total: number; label?: string; slim?: boolean; pill?: boolean; testId?: string }) {
  const { t } = useT();
  const pct = props.total > 0 ? Math.round((props.value / props.total) * 100) : 0;
  return (
    <div className={`progress ${props.slim ? 'progress-slim' : ''}`} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} data-testid={props.testId}>
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
      {props.pill ? <span className="progress-pill">{t('common.percent', { n: pct })}</span> : null}
      {props.label ? <span className="progress-label">{props.label}</span> : null}
    </div>
  );
}
